<template>
  <!-- <div id="admin-board" :style="{ backgroundImage: 'url(' + require('@/assets/imgs/background-dark.jpg') + ')'}"> -->
  <div id="admin-board">
    <!-- <side-menu id="side-bar"></side-menu> -->
    <!-- <div style="width:15%"></div> -->
    <!-- <AppHeader></AppHeader> -->
    <div class="container" style="padding:0">
      <div id="content-board">
        <keep-alive>
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </keep-alive>
      </div>
    </div>
    <Log-out></Log-out>
  </div>
</template>

<script>
import AppHeader from "@/components/fixed/terminal-header";
import SideMenu from "@/components/fixed/side-menu";
import LogOut from "@/components/dialog/log-out";
import { mapState, mapMutations, mapGetters } from "vuex";

import { introductionTutorialSteps } from "@/utils/global-constants.js";

/**
 * @author Fangzhou
 * @description dashboard page that contain a router view can route between data-board, analysis-board, setting-board and user-board
 * @version 1.0
 * @module pages
 * @name ApplicationPage
 */

export default {
  components: {
    AppHeader,
    SideMenu,
    LogOut
  },
  /**
   * @method created
   * @description hook function checkout if user already login before jump into dashboard, if not, jump back to homepage and notify user
   */
  computed: {
    auth() {
      return this.$store.getters.isLogin && this.getWindowLocalStorage("token");
    },
    ...mapState({
      userApikey: state => state.UserService.apikey
      //tutorial states
      // showIntroTutorial: state => state.UserService.showIntroTutorial,
      // shouldShowIntroTutorial: state =>
      //   state.UserService.shouldShowIntroTutorial
    })
  },

  // watch: {
  //   shouldShowIntroTutorial: function(newVal, oldVal) {
  //     // when user clicked show introduction tutorial in terminal header
  //     console.log("[application-page] route is: ", this.$route.path);
  //     if (newVal) {
  //       if (this.$route.path !== "/app/terminal") {
  //         this.$notify({
  //           group: "note",
  //           text: "Please go to the terminal page to start the tutorial",
  //           type: "error"
  //         });
  //       } else {
  //         this.startIntroductionTutorial();
  //       }
  //     }
  //     this.$store.commit("setShouldShowIntroTutorial", false);
  //   }
  // },
  methods: {
    getHeader(name) {
      if (name.includes("terminal")) return "Terminal";
      if (name.includes("admin")) return "Account";
    },

    getUserData() {
      // const vm = this;
      this.loading = true;
      const token = this.getWindowLocalStorage("token");
      this.$store
        .dispatch("getProfile", { token })
        .then(response => response.json())
        .then(res => {
          // console.log(
          //   "application-page getUserData() getProfile response is: ",
          //   res
          // );
          this.$store.commit("saveUserInfoInState", res);
          let plan = res.plan ? res.plan : "free";
          this.setWindowLocalStorage("userPlan", plan);
          this.setWindowLocalStorage("apikey", res.accessKey);
          this.setWindowLocalStorage(
            "showIntroTutorial",
            res.showIntroTutorial
          );
          // this.$store.dispatch("getUserBookMarks", res.accessKey);
        })
        .catch(err => {
          console.log("getUserData() ERROR: ", err.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // tutorial helper functions
    startIntroductionTutorial() {
      let tour = this.$introJs();
      console.log("terminal-page, mounted() tour is: ", this.$route.params);
      tour.setOption("tooltipPosition", "auto");
      tour.setOptions(introductionTutorialSteps());
      tour.start();
    }
  },
  /**
   * lifecycle events
   */

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.auth) {
        next();
      } else {
        next("/index");
      }
    });
  },
  beforeCreated() {
    const routeQuery = this.$route.params;
  },

  created() {
    const routeQuery = this.$route.params;
    if (!this.userApikey) {
      this.getUserData();
    }
  },

  mounted() {}
};
</script>
<style scoped lang="css">
* {
  font-family: Jura;
}

#admin-board {
  flex-direction: row;
  display: flex;
}

#side-bar {
  overflow: auto;
  height: 100vh;
  left: 0;
  width: 64px;
  background-color: #112027;
}

#content-board {
  flex: 1;
  height: 100vh;
  overflow: hidden;
}

#content-board > div {
  margin: auto;
}

::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
  background: transparent; /* optional: just make scrollbar invisible */
}

.main-board-bg {
  border-radius: 10px;
}

.icon {
  width: 30px;
}

.fade-enter-active {
  transition: all 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.2s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-100%);
}

@media only screen and (max-width: 768px) {
  .slide-leave-active,
  .slide-enter-active {
    transition: 0.2s;
  }
  .slide-enter {
    transform: translate(-100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }

  #admin-board {
    flex: 1;
    background-size: cover;
  }

  #content-board > div {
    width: 100%;
    margin: auto;
  }
}

.main-board {
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
  height: inherit;
  overflow: scroll;
}

.main-board::-webkit-scrollbar {
  display: none;
}

/* @media screen and (max-width: 1200px){

  .content-board > div {
    width: 80%;
    margin: auto;
  }
} */
</style>



// WEBPACK FOOTER //
// src/pages/application-page.vue